module.exports = __webpack_public_path__ + "img/px_banner.50cbbeda.png";